var site = site || {};
site.isAvedaFlagshipApp = 0;

// Flagship App Detection based on cookie provided by app webview, see: page.tpl.php
(function() {
  'use strict';
  // https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie#Example_2_Get_a_sample_cookie_named_test2
  site.isAvedaFlagshipApp = document.cookie.replace(/(?:(?:^|.*;\s*)isAvedaFlagshipApp\s*\=\s*([^;]*).*$)|^.*$/, "$1");
})();
